(function () {
  if (window.__rocoCardCarouselLoaded) return;
  window.__rocoCardCarouselLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const style = document.createElement('style');
  style.textContent = `
    .card-swipe-gallery {
      position: relative;
      overflow: hidden;
      touch-action: pan-y;
    }

    .card-swipe-img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.25s ease;
    }

    .card-swipe-img--active {
      position: relative;
      opacity: 1;
      pointer-events: auto;
    }

    @media screen and (max-width: 749px) {
      .card-swipe-gallery {
        z-index: 3;
        display: block;
        overflow: hidden !important;
        max-width: 100%;
        touch-action: pan-y;
      }

      .product-card-wrapper .full-unstyled-link::after {
        pointer-events: auto !important;
      }

      .card-swipe-gallery .card-swipe-img {
        position: absolute !important;
        inset: 0;
        width: 100%;
        height: 100%;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none;
        transition: none !important;
        user-select: none;
        -webkit-user-drag: none;
      }

      .card-swipe-gallery .card-swipe-img--active {
        position: relative !important;
        z-index: 1;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto;
      }

      .card-swipe-gallery .card-swipe-dots {
        position: relative !important;
        right: auto;
        bottom: auto;
        left: auto;
        z-index: 2;
        display: flex !important;
        width: 100%;
        height: 3px !important;
        margin: -3px 0 0;
        gap: 0;
        background: rgba(255, 255, 255, 0.55);
        transform: none;
        pointer-events: none;
      }

      .card-swipe-gallery .card-swipe-dot {
        flex: 1 1 auto;
        width: auto;
        height: 3px !important;
        border-radius: 0;
        background: transparent;
        transition: background 0.18s ease;
      }

      .card-swipe-gallery .card-swipe-dot--active {
        background: rgba(25, 25, 25, 0.88);
      }
    }
  `;
  document.head.appendChild(style);

  let suppressClickUntil = 0;
  let activeGesture = null;
  let activeTouch = null;

  function openProduct(gallery) {
    const link = gallery.closest('.card-wrapper')?.querySelector('.card__heading a[href]');
    if (link) window.location.assign(link.href);
  }

  function initCarousel(gallery) {
    if (gallery.dataset.swipeInit === 'native') return;
    gallery.dataset.swipeInit = 'native';

    const images = Array.from(gallery.querySelectorAll('.card-swipe-img'));
    const dots = Array.from(gallery.querySelectorAll('.card-swipe-dot'));
    if (images.length < 2) return;

    let current = 0;

    function update(index) {
      const next = Math.max(0, Math.min(index, images.length - 1));
      if (next === current && dots[next]?.classList.contains('card-swipe-dot--active')) return;

      images[current]?.classList.remove('card-swipe-img--active');
      dots[current]?.classList.remove('card-swipe-dot--active');
      images[current]?.setAttribute('aria-hidden', 'true');

      current = next;
      gallery.dataset.swipeIndex = String(current);
      images[current]?.classList.add('card-swipe-img--active');
      dots[current]?.classList.add('card-swipe-dot--active');
      images[current]?.setAttribute('aria-hidden', 'false');
    }

    gallery.dataset.swipeIndex = '0';
    gallery.cardSwipeUpdate = update;

    images.forEach((image, index) => {
      image.setAttribute('draggable', 'false');
      image.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
    });

    gallery.addEventListener('click', () => {
      if (!mobileQuery.matches || Date.now() < suppressClickUntil) return;
      openProduct(gallery);
    });
  }

  function galleryAtPoint(x, y) {
    return Array.from(document.querySelectorAll('.card-swipe-gallery')).find((gallery) => {
      const rect = gallery.getBoundingClientRect();
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    });
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!mobileQuery.matches || !event.isPrimary || event.pointerType === 'touch') return;
      const gallery = galleryAtPoint(event.clientX, event.clientY);
      if (!gallery || gallery.querySelectorAll('.card-swipe-img').length < 2) return;

      activeGesture = {
        gallery,
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startIndex: Number(gallery.dataset.swipeIndex || 0),
        horizontal: false,
        lastX: event.clientX
      };
    },
    true
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!activeGesture || activeGesture.pointerId !== event.pointerId) return;

      const distanceX = event.clientX - activeGesture.startX;
      const distanceY = event.clientY - activeGesture.startY;

      if (!activeGesture.horizontal) {
        if (Math.abs(distanceX) < 8 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        activeGesture.horizontal = true;
      }

      event.preventDefault();
      activeGesture.lastX = event.clientX;
    },
    { capture: true, passive: false }
  );

  function finishGesture(event) {
    if (!activeGesture || activeGesture.pointerId !== event.pointerId) return;

    const gesture = activeGesture;
    activeGesture = null;
    if (!gesture.horizontal) return;

    const images = gesture.gallery.querySelectorAll('.card-swipe-img');
    if (event.type === 'pointercancel') return;

    const distance = gesture.lastX - gesture.startX;
    const threshold = Math.min(45, gesture.gallery.clientWidth * 0.18);
    let next = gesture.startIndex;

    if (distance <= -threshold) {
      next = Math.min(gesture.startIndex + 1, images.length - 1);
    } else if (distance >= threshold) {
      next = Math.max(gesture.startIndex - 1, 0);
    }

    gesture.gallery.cardSwipeUpdate?.(next);
    suppressClickUntil = Date.now() + 500;
  }

  document.addEventListener('pointerup', finishGesture, true);
  document.addEventListener('pointercancel', finishGesture, true);

  function findTouch(touchList, identifier) {
    for (let index = 0; index < touchList.length; index += 1) {
      if (touchList[index].identifier === identifier) return touchList[index];
    }
    return null;
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;

      const touch = event.touches[0];
      const gallery = galleryAtPoint(touch.clientX, touch.clientY);
      if (!gallery || gallery.querySelectorAll('.card-swipe-img').length < 2) return;

      activeTouch = {
        gallery,
        identifier: touch.identifier,
        startX: touch.clientX,
        startY: touch.clientY,
        lastX: touch.clientX,
        startedAt: Date.now(),
        startIndex: Number(gallery.dataset.swipeIndex || 0),
        horizontal: false
      };
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!activeTouch) return;

      const touch = findTouch(event.touches, activeTouch.identifier);
      if (!touch) return;

      const distanceX = touch.clientX - activeTouch.startX;
      const distanceY = touch.clientY - activeTouch.startY;

      if (!activeTouch.horizontal) {
        if (Math.abs(distanceX) < 8 && Math.abs(distanceY) < 8) return;
        if (Math.abs(distanceY) >= Math.abs(distanceX)) {
          activeTouch = null;
          return;
        }
        activeTouch.horizontal = true;
      }

      activeTouch.lastX = touch.clientX;
      if (event.cancelable) event.preventDefault();
    },
    { capture: true, passive: false }
  );

  function finishTouch(event) {
    if (!activeTouch) return;

    const gesture = activeTouch;
    const touch = findTouch(event.changedTouches, gesture.identifier);
    activeTouch = null;

    if (event.type === 'touchcancel') return;
    if (touch) gesture.lastX = touch.clientX;

    if (!gesture.horizontal) {
      const distanceX = Math.abs(gesture.lastX - gesture.startX);
      const distanceY = touch ? Math.abs(touch.clientY - gesture.startY) : 0;
      if (distanceX <= 10 && distanceY <= 10 && Date.now() - gesture.startedAt <= 700) {
        suppressClickUntil = Date.now() + 650;
        openProduct(gesture.gallery);
      }
      return;
    }

    const images = gesture.gallery.querySelectorAll('.card-swipe-img');
    const distance = gesture.lastX - gesture.startX;
    const threshold = Math.min(35, gesture.gallery.clientWidth * 0.15);
    let next = gesture.startIndex;

    if (distance <= -threshold) {
      next = Math.min(gesture.startIndex + 1, images.length - 1);
    } else if (distance >= threshold) {
      next = Math.max(gesture.startIndex - 1, 0);
    }

    gesture.gallery.cardSwipeUpdate?.(next);
    suppressClickUntil = Date.now() + 650;
  }

  document.addEventListener('touchend', finishTouch, true);
  document.addEventListener('touchcancel', finishTouch, true);

  document.addEventListener(
    'click',
    (event) => {
      if (!mobileQuery.matches || Date.now() >= suppressClickUntil) return;
      const card = event.target.closest('.product-card-wrapper, .card-wrapper');
      if (!card?.querySelector('.card-swipe-gallery')) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  function initAll() {
    document.querySelectorAll('.card-swipe-gallery').forEach(initCarousel);
  }

  function start() {
    initAll();
    const observer = new MutationObserver(initAll);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

